import { Ref, ref, watch } from 'vue'

import { Incident } from '@collector/sportsapi-client'
import { useIncidents } from '@desktop/views/Relation/composables'
import { IncidentsGroup } from '@desktop/views/Relation/Sports/configuration'
import { buildIncidentsGroups } from '@desktop/views/Relation/Sports/configuration/buildIncidentsGroups'
import { injectIncidentIdsGroup } from '@desktop/views/Relation/Sports/provide-inject'

type UseIncidentsGroup = {
  incidentsGroups: Ref<(Incident | IncidentsGroup)[]>
}

export function useIncidentsGroup(): UseIncidentsGroup {
  // composables
  const { incidents } = useIncidents()

  // inject
  const incidentIdsGroup = injectIncidentIdsGroup()

  // state
  const incidentsGroups = ref<(Incident | IncidentsGroup)[]>([])

  // methods
  function rebuildIncidentsGroups(): void {
    incidentsGroups.value = buildIncidentsGroups(
      incidents.value,
      incidentIdsGroup,
    )
  }

  watch(incidents, rebuildIncidentsGroups, { deep: true, immediate: true })

  return {
    incidentsGroups,
  }
}
